/**
 * Feature flags.
 */

export const features = {
    timeslicer: true,
    hasBrand: false
};
